import React, { FC } from 'react';
import { useI18n } from '~Hooks';
import HandyPageWrapper from '~Scenes/Handy/Components/HandyPageWrapper';
import KitchenTicketsSettings from '~Scenes/Settings-v2/Scenes/KitchenTickets';

/** Handheld shell around the shared Settings-v2 kitchen tickets scene */
const KitchenTickets: FC = () => {
  const { i18n } = useI18n();

  return (
    <HandyPageWrapper pageTitle={i18n('Handy.Settings.KitchenTickets')}>
      <KitchenTicketsSettings isHandy />
    </HandyPageWrapper>
  );
};

export default KitchenTickets;
